import PreparationCard from "../../../../../ReusableComponent/PreparationCards"

const categories = [
  {
    title: "Technical Aptitude",
    description: "Programming fundamentals and logical reasoning",
    duration: 90,
    questions: 50,
    subjects: ["Data Structures", "Algorithms", "Programming Logic", "Problem Solving"],
    difficulty: "Medium",
  },
  {
    title: "Competitive Programming",
    description: "Advanced coding competitions preparation",
    duration: 120,
    questions: 5,
    subjects: ["Dynamic Programming", "Graph Theory", "Number Theory", "Greedy Algorithms"],
    difficulty: "Hard",
  },
  {
    title: "Core Computer Science",
    description: "Fundamental CS subjects for interviews",
    duration: 60,
    questions: 40,
    subjects: ["Operating Systems", "Database Management", "Computer Networks", "Software Engineering"],
    difficulty: "Medium",
  },
  {
    title: "Frontend Development",
    description: "Frontend technologies and frameworks",
    duration: 75,
    questions: 35,
    subjects: ["JavaScript", "React", "HTML/CSS", "Web APIs"],
    difficulty: "Easy",
  },
];

function CategoriesSection() {
  return (
    <section className="row mx-0 py-5 my-5 d-flex justify-content-center align-items-center">
      <div className="col-md-11 col-12">
        <div className="row mx-0 d-flex justify-content-center align-items-center">
          <div className="col-12 text-center mb-4">
            <h2 className="fw-bold text-light">Exam Categories</h2>
          </div>
          <div className="row mx-0">
            {categories.map((cat, idx) => (
              <PreparationCard key={idx} {...cat} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CategoriesSection;